module.exports = __webpack_public_path__ + "static/media/chat_bubble_large.69fdd3e7.svg";